import styled from 'styled-components';
import { Button as ButtonComponent } from 'components/Button';
import { DEVICE } from 'constants/app/breakpoints';

export const Button = styled(ButtonComponent)`
  &&& {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    width: 100%;
    margin: 12px 0;
    display: flex;
    justify-content: center;
  }
`;

export const PaymentButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 4px;

  @media screen and ${DEVICE.xl} {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: var(--v3-black-0);
    padding: 16px 24px 24px;
    z-index: 10;
  }
`;

export const FormContainer = styled.div`
  margin-top: 24px;
  min-height: 228.45px;
`;
